import { render } from "./PdfAppointmentTable.vue?vue&type=template&id=3252162e&scoped=true&ts=true"
import script from "./PdfAppointmentTable.vue?vue&type=script&lang=ts"
export * from "./PdfAppointmentTable.vue?vue&type=script&lang=ts"

import "./PdfAppointmentTable.vue?vue&type=style&index=0&id=3252162e&lang=scss&scoped=true"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3252162e"]])

export default __exports__